module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-8.12cb15d2.png";